import { graphql, useFragment } from "react-relay";
import { AudienceGroupsFragment$key } from "./__generated__/AudienceGroupsFragment.graphql";

const Fragment = graphql`
  fragment AudienceGroupsFragment on AudienceGroupConnection {
    nodes {
      id
      label
      position
      items {
        label
      }
    }
  }
`;

interface Props {
  audience: AudienceGroupsFragment$key;
}

export function AudienceGroups(props: Props) {
  const { nodes: groups } = useFragment(Fragment, props.audience);

  return (
    <div className="flex flex-col gap-4">
      {groups.map((audience) => (
        <div key={audience.id}>
          <p className="text-grey-700 text-base font-semibold leading-6">
            {audience.label}
          </p>
          <ul className="list-disc pl-5 flex flex-col gap-0.5">
            {audience.items.map(({ label }) => (
              <li key={label} className="text-base font-normal text-grey-600">
                {label}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
